export const authScreens = {
  accesoDirecto: {
    loading: "Entrando na sua conta…",
  },
  confirmar: {
    verifying: "Verificando a conta…",
    verifiedSuccess: "Conta verificada com sucesso",
    tokenInvalid: "O token não existe ou já expirou",
    backHome: "Voltar ao início",
  },
  recovery: {
    title: "Redefinir senha",
    successTitle: "Sucesso!",
    successDesc:
      "Sua senha foi alterada com sucesso. Redirecionando você para o início…",
    infoTitle: "Crie uma nova senha",
    infoDesc:
      "Ao alterá-la, todas as sessões ativas nos seus outros dispositivos serão encerradas.",
    newPasswordLabel: "Nova senha",
    newPasswordPlaceholder: "Digite sua nova senha",
    togglePasswordAria: "Mostrar/ocultar senha",
    confirmPasswordLabel: "Repetir senha",
    confirmPasswordPlaceholder: "Repita sua nova senha",
    passwordsMismatch: "As senhas não coincidem.",
    submit: "Alterar senha",
    submitting: "Processando…",
    backToStart: "Voltar ao início",
    footerWeb: "Site",
    toastInvalidLink: "O link de recuperação é inválido ou expirou.",
    errorGeneric: "Não foi possível alterar a senha.",
  },
};
